import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIClient } from "../../../helpers/ApiHelper";

export const login = createAsyncThunk(
  "loginTest",
  async ({ email, password, headers }, { rejectWithValue }) => {
    try {
      const apiClient = new APIClient();
      return await apiClient.create(
        "/api/v1/authentication/login",
        { email, password },
        headers
      );
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const loginSlice = createSlice({
  name: "LoginTestSlice",
  initialState: {
    loading: false,
    error: false,
    errorMsg: null,
    user: {
      email: "",
      name: "",
      surname: "",
      accessToken: "",
      refreshToken: "",
      userId: "",
      clientId: null,
      type: "",
      deviceId: "",
    },
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.loading = true;
        state.error = false;
        state.errorMsg = null;
      })
      .addCase(login.fulfilled, (state, action) => {
        const data = action.payload.data;
        state.loading = false;
        state.user = {
          email: data.user.email,
          name: data.user.name,
          surname: data.user.surname,
          accessToken: data.accessToken,
          refreshToken: data.refreshToken,
          userId: data.user.userId,
          clientId: data.user.clientId,
          type: data.user.type,
          deviceId: data.device.id,
        };
        state.error = false;
        state.errorMsg = null;

        sessionStorage.setItem(
          "authUserData",
          JSON.stringify({
            email: data.user.email,
            name: data.user.name,
            surname: data.user.surname,
            accessToken: data.accessToken,
            refreshToken: data.refreshToken,
            userId: data.user.userId,
            clientId: data.user.clientId,
            type: data.user.type,
            deviceId: data.device.id,
          })
        );
      })
      .addCase(login.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        state.errorMsg = action.payload.message;
      });
  },
});

export default loginSlice.reducer;
